export default __webpack_public_path__ + "static/media/undraw_create_account.726aad3c.svg";